if (!customElements.get('nl-lifestyle')) {
  customElements.define('nl-lifestyle', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.failedVariants = new Set();
      this.variants = this.closest('product-page')?.querySelector('product-variants[data-main-product-variants]');
      this.variants?.addEventListener('VARIANT_CHANGE', event => {
        this.showVariant(event.target.currentVariant?.id);
      }, { signal: this.controller.signal });
      if (this.variants?.currentVariant) this.showVariant(this.variants.currentVariant.id);
      this.bindImageError();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    showVariant(id) {
      const template = !this.failedVariants.has(String(id)) && Array.from(this.querySelectorAll(':scope > template[data-lifestyle-for]'))
        .find(item => item.dataset.lifestyleFor === String(id));
      const active = this.querySelector(':scope > .nl-lifestyle__figure');
      if (template && active?.dataset.lifestyleVariant === String(id)) {
        this.hidden = false;
        return;
      }
      active?.remove();
      this.hidden = !template;
      if (template) {
        this.append(template.content.cloneNode(true));
        this.bindImageError();
      }
    }

    bindImageError() {
      this.querySelector(':scope > .nl-lifestyle__figure img')?.addEventListener('error', () => {
        this.failedVariants.add(this.querySelector(':scope > .nl-lifestyle__figure')?.dataset.lifestyleVariant);
        this.hidden = true;
      }, { once: true, signal: this.controller.signal });
    }
  });
}
